import { FC } from 'react';
import { useTranslate } from '@/i18n/useTranslate';

export const Img: FC<{ src: string | undefined }> = ({ src }) => {
  const { t } = useTranslate('common');
  return <img src={src} alt={t('QR_CODE')} />;
};
